const ActionStates = {
    LOAD_BOX: 0,
    COMPLETE_BOX: 1,
    PACK_MODE: 2
};

export default {
    ActionStates
}